export default "__VITE_ASSET__DPGUMxGp__"